export default {
  modelName: 'idtf_update',
  versionModelName: 'act_version',
  label: '我的鑑別作業',
};
